import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=634de093&scoped=true&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634de093",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634de093')) {
      api.createRecord('634de093', component.options)
    } else {
      api.reload('634de093', component.options)
    }
    module.hot.accept("./OrderConfirmation.vue?vue&type=template&id=634de093&scoped=true&", function () {
      api.rerender('634de093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/OrderConfirmation.vue"
export default component.exports